import React, { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Link,
  Stack,
  Button,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { HashLink } from "react-router-hash-link";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  link: {
    textDecoration: "none !important",
    color: "#fff !important",
    fontSize: "20px",
    fontWeight: "bold",
  },
}));

export default function DrawerComponent() {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <>
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Stack sx={{ bgcolor: "#000", height: "100%", pt: "40px" }}>
          <List>
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/about" className={classes.link}>
                  ABOUT
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/roadmap" className={classes.link}>
                  ROADMAP
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/membership" className={classes.link}>
                  MEMBERSHIP
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/culturemaker" className={classes.link}>
                  CULTURE MAKER
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/memories" className={classes.link}>
                  MEMORIES
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/team" className={classes.link}>
                  TEAM
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/mint" className={classes.link}>
                  MINT
                </HashLink>
              </ListItemText>
            </ListItem>

            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <HashLink to="/education" className={classes.link}>
                  EDUCATION
                </HashLink>
              </ListItemText>
            </ListItem>
          </List>
        </Stack>
      </Drawer>
      <IconButton onClick={() => setOpenDrawer(!openDrawer)}>
        <Icon
          icon="ant-design:menu-outlined"
          color="#b6e094"
          width="40"
          height="40"
        />
      </IconButton>
    </>
  );
}
